/**
 * Admin Authentication Hook
 * Gerencia autenticação do admin console
 */
import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface AdminUser {
  id: string
  name: string
  email: string
  role: 'super_admin' | 'admin' | 'support' | 'analyst'
  avatar?: string
}

interface AdminAuthState {
  user: AdminUser | null
  token: string | null
  isLoading: boolean
  isAuthenticated: boolean
  login: (email: string, password: string) => Promise<void>
  logout: () => void
}

export const useAdminAuth = create<AdminAuthState>()(
  persist(
    (set) => ({
      user: null,
      token: null,
      isLoading: false,
      isAuthenticated: false,
      
      login: async (email: string, password: string) => {
        set({ isLoading: true })
        
        try {
          // TODO: Implementar chamada real à API
          // Simulação para desenvolvimento
          await new Promise(resolve => setTimeout(resolve, 1000))
          
          if (email === 'admin@workstream.com' && password === 'admin123') {
            set({
              user: {
                id: '1',
                name: 'Admin WorkStream',
                email: 'admin@workstream.com',
                role: 'super_admin',
              },
              token: 'mock-admin-token',
              isAuthenticated: true,
              isLoading: false,
            })
          } else {
            throw new Error('Credenciais inválidas')
          }
        } catch (error) {
          set({ isLoading: false })
          throw error
        }
      },
      
      logout: () => {
        set({
          user: null,
          token: null,
          isAuthenticated: false,
        })
      },
    }),
    {
      name: 'workstream-admin-auth',
      partialize: (state) => ({
        user: state.user,
        token: state.token,
        isAuthenticated: state.isAuthenticated,
      }),
    }
  )
)

